import React from 'react';
import ModalContainer from './ModalContainer';

/**
 * ModalRenderer - Renders the currently open modal
 *
 * This component renders a single modal at a time using ModalContainer.
 * It has been simplified to handle only one modal since the application
 * design only supports one modal open at a time.
 *
 * @param {Object} props - Component props
 * @param {Object|null} [props.currentModal=null] - Current modal state or null if no modal is open
 * @param {string} props.currentModal.modalId - Modal identifier
 * @param {boolean} props.currentModal.isOpen - Whether the modal is open
 * @param {Object} [props.currentModal.data] - Modal data
 * @param {boolean} [props.currentModal.loading] - Loading state
 * @param {Object} [props.currentModal.errors] - Error state
 * @param {Object} [props.currentModal.config] - Modal configuration
 * @param {Function} props.onClose - Function to close the modal
 * @param {Function} props.onSubmit - Function to handle modal submission
 * @param {Function} props.onUpdate - Function to update modal state
 * @param {Object|null} [props.userInfo=null] - Current user information
 * @param {Array} [props.roles=[]] - Available user roles
 * @param {Object} [props.globalProps={}] - Global props to pass to the modal
 * @returns {JSX.Element|null} Rendered modal or null
 */
const ModalRenderer = ({
  currentModal = null,
  onClose,
  onSubmit,
  onUpdate,
  userInfo = null,
  roles = [],
  globalProps = {},
}) => {
  // If no modal is open, render nothing
  if (!currentModal || !currentModal.isOpen) {
    return null;
  }

  return (
    <ModalContainer
      modalId={currentModal.modalId}
      modalState={currentModal}
      onClose={onClose}
      onSubmit={onSubmit}
      onUpdate={onUpdate}
      userInfo={userInfo}
      roles={roles}
      additionalProps={globalProps}
    />
  );
};

export default ModalRenderer;
